import { useState, useEffect } from 'react';
import Button, { BUTTON_TYPE_CLASSES } from '../../../components/button/button.component';
import { Link, useNavigate } from 'react-router-dom';
import Image from '../../../components/image/image.component';
import { Form, Formik } from "formik";
import * as Yup from 'yup';
import InputField from '../../Input-field/input-field.component';
import Alert, { ALERT_TYPE } from '../../alert/alert.component';
import { user_forgetpass } from '../../../Services/prod/auth.service';

const ForgotPasswordConfirmationMessage = ({ handleNext, formProps }) => {
    const { values } = formProps;
    const navigate = useNavigate();
    const [status, setStatus] = useState('');
    const [userStatus, setUserStatus] = useState('');
    const [loading, setLoading] = useState(false);
    const [countdown, setCountdown] = useState(0);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);

    const goToConfirm = () => {
        navigate('/auth/reset-password', { state: { email: values.email } });
    }

    const sendAgain = () => {
        setStatus('');
        setUserStatus('');
        setLoading(true);
        setIsButtonDisabled(true);
        setCountdown(60); 

        user_forgetpass(values.email).then(data => {
            if (data && data.isSuccess === true) {
                console.log(data);
                setUserStatus("Email sent.");
            } else {
                setStatus(data.message);
            }
        }).finally(() => {
            setLoading(false);
        });
    }

    useEffect(() => {
        let timer;
        if (countdown > 0) {
            timer = setInterval(() => {
                setCountdown(prev => prev - 1);
            }, 1000);
        } else {
            setIsButtonDisabled(false);
        }
        return () => clearInterval(timer);
    }, [countdown]);

    return (
        <>
            <div className='title'>
                <Image src={'logo.png'} alt={'Music Bull'} width={150} />
                <h2>Welcome to Musicbull!</h2>
            </div>
            <div>
                {status && <Alert style={{ margin: "0px 0px 1rem" }} alertType={ALERT_TYPE.error}>{status}</Alert>}
                {userStatus && <Alert style={{ margin: "0px 0px 1rem" }} alertType={ALERT_TYPE.success}>{userStatus}</Alert>}
                <div style={{ textAlign: "center" }}>
                    <p>Please verify your account by checking your email at {values.email} for the activation code and enter it in the next step.</p>
                    <p>If you can't find the email in your inbox, be sure to check your spam folder.</p>
                    <Button color="blue" onClick={goToConfirm}>Continue</Button>
                    <p style={{ marginTop: "15px" }}>Did not receive the code?</p>
                    <Button disabled={isButtonDisabled || loading} buttonType={BUTTON_TYPE_CLASSES.TextButton} color="blue" onClick={sendAgain} style={{ marginTop: "0px" }}>
                        Send again
                    </Button>
                    {isButtonDisabled && (
                        <p style={{ color: 'gray', marginTop: '10px' }}>
                            Try again in {countdown} seconds
                        </p>
                    )}
                </div>
            </div>
        </>
    );
}

export default ForgotPasswordConfirmationMessage;
